import { useEffect } from "react"
import {ThunkDispatch} from "@reduxjs/toolkit";
import {connect, useDispatch } from "react-redux"
import {useNavigate} from 'react-router-dom'
import { Modal } from "flowbite-react";
import {CloseModalIcon, ConfirmGenerateAfterPhotoIcon} from '../SVGIcons'
import {currentUserActions} from '../../reducers/currentUser'

function mapStateToProps(state: any) {
  return { ...state.currentUser }
}

const LoginAgainPopup = (props: any) => {
  const {
    isLoginAgainPopupShow,
  } = props
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>()
  const navigate = useNavigate()
  const closePopup = () => {
    dispatch(currentUserActions.setIsLoginAgainPopupShow(false))
  }
  const signInUser = () => {
    dispatch(currentUserActions.signInUser({navigate, isLoginAgain: true}))
  }

  return (
    <>
      <Modal show={isLoginAgainPopupShow} onClose={closePopup} size="md">
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
              <button type="button" onClick={closePopup}
                className="absolute top-3 end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center">
                <CloseModalIcon />
                <span className="sr-only">閉じる</span>
              </button>
              <div className="p-4 md:p-5 text-center">
                <h3 className="text-lg font-semibold leading-6 text-gray-900">このユーザIDは別端末で使用中です。</h3>
                <h3 className="text-lg font-semibold leading-6 text-gray-900">別端末を強制的にログアウトし、</h3>
                <h3 className="text-lg font-semibold leading-6 text-gray-900">この端末でログインしますか？</h3>
                <br />
                <p>他のユーザが利用している場合に本操作を行うと、</p>
                <p>家具生成が失敗し、実行回数が消費される可能性がございます。</p>
                <div className=" items-center mt-6 space-x-4">
                  <button type="button" onClick={signInUser}
                    className="sm:ml-3 w-28 text-white submit-btn hover:submit-btn focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">ログイン</button>
                  <button type="button" onClick={closePopup}
                    className="sm:ml-3 w-28 py-2.5 px-5 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-300 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100">キャンセル</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default connect(mapStateToProps)(LoginAgainPopup)
